import React, { useState } from "react";
import { authService } from "../services/api";
export default function LoginPage({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await authService.login(email, password);
      localStorage.setItem("access_token", res.data.tokens.access);
      localStorage.setItem("refresh_token", res.data.tokens.refresh);
      localStorage.setItem("user", JSON.stringify(res.data.user));
      onLogin();
    } catch {
      setError("Email ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #0F3D1A, #1A5C2A)", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Poppins, sans-serif" }}>
      <div style={{ background: "white", borderRadius: 24, padding: 48, width: 400, boxShadow: "0 20px 60px rgba(0,0,0,0.2)" }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ width: 80, height: 80, background: "#1A5C2A", borderRadius: 20, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", fontSize: 32 }}>🏛️</div>
          <h1 style={{ color: "#1A5C2A", fontSize: 22, fontWeight: 800, margin: 0 }}>Bot-Makak Admin</h1>
          <p style={{ color: "#8A8A9A", fontSize: 13, margin: "4px 0 0" }}>Panneau d'administration</p>
        </div>
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A1A2E", marginBottom: 6 }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="admin@commune-botmakak.net"
              style={{ width: "100%", padding: "12px 16px", border: "1px solid #E8E8F0", borderRadius: 12, fontSize: 14, fontFamily: "Poppins", boxSizing: "border-box", outline: "none" }} />
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ display: "block", fontSize: 13, fontWeight: 600, color: "#1A1A2E", marginBottom: 6 }}>Mot de passe</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="••••••••"
              style={{ width: "100%", padding: "12px 16px", border: "1px solid #E8E8F0", borderRadius: 12, fontSize: 14, fontFamily: "Poppins", boxSizing: "border-box", outline: "none" }} />
          </div>
          {error && <p style={{ color: "red", fontSize: 13, marginBottom: 16, textAlign: "center" }}>{error}</p>}
          <button type="submit" disabled={loading}
            style={{ width: "100%", padding: "14px", background: loading ? "#8A8A9A" : "linear-gradient(135deg, #0F3D1A, #1A5C2A)", color: "white", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", fontFamily: "Poppins" }}>
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}